import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|History|Audit|Detail|Certs';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryAuditCertsLoc =
	| 'SPCandidateHistoryAuditCertsTitle'
	| 'SPCandidateHistoryAuditCertsTableCcatName'
	| 'SPCandidateHistoryAuditCertsTableCertActiveDate'
	| 'SPCandidateHistoryAuditCertsTableCertExpireDate'
	| 'SPCandidateHistoryAuditCertsTableCertLatestExtendDate'
	| 'SPCandidateHistoryAuditCertsTableState';

export const spCandidateHistoryAuditCertsLocs: LocDefs<SPCandidateHistoryAuditCertsLoc> = {
	SPCandidateHistoryAuditCertsTitle: {
		defaultValue: 'Candidate Certifications',
		description: 'Section title for the candidate history audit detail certifications section.',
		displayPath: `${dpRoot}|Section Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditCertsTableCcatName: {
		defaultValue: 'Certification',
		description: 'Table column header for the certification name.',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditCertsTableCertActiveDate: {
		defaultValue: 'Active Date',
		description: 'Table column header for the certification active date.',
		displayPath: `${dpRoot}|Active Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditCertsTableCertExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Table column header for the certification expire date.',
		displayPath: `${dpRoot}|Expire Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditCertsTableCertLatestExtendDate: {
		defaultValue: 'Latest Extend Date',
		description: 'Table column header for the certification latest extend date.',
		displayPath: `${dpRoot}|Latest Extend Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditCertsTableState: {
		defaultValue: 'State',
		description: 'Table column header for the certification state.',
		displayPath: `${dpRoot}|State`,
		displayType: 'Label',
		...sharedProps,
	},
};

export const spCandidateHistoryAuditCertsLocKeys = MapLocKeys<SPCandidateHistoryAuditCertsLoc>(
	spCandidateHistoryAuditCertsLocs
);
export type SPCandidateHistoryAuditCertsLocKeys = typeof spCandidateHistoryAuditCertsLocKeys;
